function required(name: keyof ImportMetaEnv): string {
  const v = import.meta.env[name];
  if (typeof v !== 'string' || v === '') {
    throw new Error(`missing env: ${name}`);
  }
  return v;
}

export const env = {
  apiOrigin: required('VITE_API_ORIGIN'),
  posthogKey: import.meta.env.VITE_POSTHOG_KEY,
  posthogHost: import.meta.env.VITE_POSTHOG_HOST,
  buildSha: import.meta.env.VITE_BUILD_SHA ?? 'dev',
  // Public base URL for apartment-photo R2 objects, prefixed to the
  // server-built R2 key (apartments/<apt>/<photo>.<ext>). Both envs use an
  // in-zone custom binding from infra/cloudflare — assets.<domain> in prod,
  // staging-assets.<domain> on staging (OH-116) — because Image
  // Transformations only exist inside the zone. Baked in at BUILD time by
  // deploy-pms-*.yml, so changing the secret needs a rebuild, not a restart.
  // Unset in local dev — photo <img> tags will fail to load and the UI
  // shows a placeholder card.
  r2PublicBase: import.meta.env.VITE_R2_PUBLIC_BASE ?? '',
};
